import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../../../Hooks/useAuthContext";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"

import Spinner from "../../../Components/Loading/Spinner";



export default function RecentOrderStats({  }) {
    const { user } = useAuthContext();
    const [orderStats, setOrderStats] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/stats/recentorders`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                setLoading(false);
                if (res.status === 200) {
                    console.log("response:", res.data);
                    setOrderStats(res.data);
                }
            })
    }, [])

    const styles = {
        contentBox: {
            backgroundColor: "#A6A6A6",
            padding: 20,
            textAlign: "center"
        }
    }


    return (
        <>
        {  loading && (<Spinner />)}
        { !loading && (
                <div className="row">
                    <div className="col-3">
                        <div className="contentBox" style={styles.contentBox}>
                            <h4>Orders</h4>
                            <h4>{orderStats.orders.toFixed()}</h4>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="contentBox" style={styles.contentBox}>
                            <h4>Value</h4>
                            <h4>&pound;{orderStats.value.toFixed()}</h4>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="contentBox" style={styles.contentBox}>
                            <h4>Net Contribution</h4>
                            <h4>&pound;{orderStats.netContribution.toFixed()}</h4>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="contentBox" style={styles.contentBox}>
                            <h4>Commission</h4>
                            <h4>&pound;{orderStats.commission.toFixed()}</h4>
                        </div>
                    </div>
                </div>)
            }
        </>
    )
}
